import React, { Component } from "react";
import styled from "styled-components";
import moment from 'moment';
import { SecondaryButton, DefaultModuleHeader, ButtonSizeOptions, ImageLoader, ButtonIcon } from "@loanbossinc/component-library";
import { AddCircleOutline } from "@material-ui/icons";
const StyledImageHeader = styled.div`
&& {
    height: 30px;
    width: 30px;
    margin-bottom: 0.4em;
    display: inline-block;
    vertical-align: top !important;
}`;

const StyledImageLoader = styled(ImageLoader)`
   && {
       height: 30px;
       width: 30px;
   } 
`;

const StyledButton = styled(AddCircleOutline)`
    &&&& {
        padding-top: 0.3em;
        padding-left: 0.3em;
        color: #005AA9;
        height: 20px;
        width: 20px;
        cursor: pointer;
        margin-top: 7px;
        margin-left: 7px;
    }
`;
export class ActiveLoanHeader extends Component {

    getHeaderImages = (elements) => {
        const { addLoan, authentication } = this.props;
        if (elements && elements.length > 0 && authentication) {
            return elements.reduce((accum, cur, index) => {
                if (!cur || !cur.lenderName) return accum;
                accum.push(
                    <StyledImageHeader key={index}>
                        <StyledImageLoader src={cur.logo} defaultImage={process.env.PUBLIC_URL + "/images/default-lender-icon.svg"} title={cur.lenderName} key={index} />
                    </StyledImageHeader>);
                if (index === elements.length - 1 && !authentication.isGuest) accum.push(<StyledButton onClick={() => addLoan()} key={elements.length} />);
                return accum;
            }, []);
        }

        return [
            (<StyledImageHeader key={1}><StyledImageLoader src={""} defaultImage={process.env.PUBLIC_URL + "/images/default-lender-icon.svg"} title={"Lender Selection Needed"} key={1} /></StyledImageHeader>),
            (<StyledButton onClick={() => addLoan()} key={2} />)
        ];
    }

    getHeadingTitle = () => {
        const { loans } = this.props;
        if (!loans.length) return null;
        if (loans.length === 1 && loans[0] && loans[0].loanSeniority) {
            const loanSeniority = loans[0].loanSeniority.value;
            const closingDate = loans[0].closingDate ? moment(loans[0].closingDate).format('YYYY') : "";
            return `${loanSeniority} ${closingDate}`;
        }
        return `${loans.length} Loans`;
    }

    getSubTitle = (uniqueLenders) => {
        if (uniqueLenders && uniqueLenders.length > 0) {
            const lenderNames = uniqueLenders.reduce((accum, cur) => {
                if (!cur || !cur.lenderName) return accum;
                accum.push(cur.lenderName);
                return accum;
            }, []).join(", ");
            return lenderNames.length > 60 ? lenderNames.slice(0, 60) + "..." : lenderNames;
        }

    }

    getButton = () => {
      const { buttonTitle, buttonOnClick } = this.props;
      if (!buttonTitle?.length || !buttonOnClick) {
         return null;
      }
      return (<SecondaryButton size={ButtonSizeOptions.smFluid} label={buttonTitle} onClick={() => buttonOnClick()} />)
    }

    render() {
        const { distinctLenders } = this.props;
        return (
            <DefaultModuleHeader
                headerElement={this.getHeaderImages(distinctLenders)}
                headerTitle={this.getHeadingTitle()}
                subTitle={this.getSubTitle(distinctLenders)}
                button={this.getButton()}
            />
        )
    }
}
